import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function TabelaVendaExcel(produtos) {
  // Título do relatório (em Excel, pode ser uma linha extra no topo)
  const titulo = [["Relatório de Produtos"]];

  // Cabeçalho da tabela
  const cabecalho = [["Código", "Nome", "Ncm", "St", "Estoque", "Venda"]];

  // Dados dos produtos formatados
  const dados = produtos.map((produto) => [
    produto.COD_PRODUTO,
    produto.DESCRICAO,
    produto.NCM,
    produto.ST,
    Number(produto.ESTOQUE).toFixed(3),
    `R$ ${Number(produto.VENDA).toFixed(2)}`,
  ]);

  // Junta todas as partes: título, cabeçalho e dados
  const planilhaCompleta = [...titulo, [], ...cabecalho, ...dados];

  // Cria worksheet (planilha)
  const worksheet = XLSX.utils.aoa_to_sheet(planilhaCompleta);

  // Define larguras de coluna
  worksheet["!cols"] = [
    { wch: 10 },  // Código
    { wch: 40 },  // Nome
    { wch: 12 },  // Ncm
    { wch: 6 },   // St
    { wch: 10 },  // Estoque
    { wch: 15 },  // Venda
  ];

  // Cria o workbook e adiciona a worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Relatório");

  // Converte o workbook para um array buffer
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  // Cria e salva o arquivo
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, "Relatorio_Produtos.xlsx");
}

export default TabelaVendaExcel;